import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const EngagementMetricsChart = ({ data }) => {
  return (
    <div className="card">
      <h3 className="text-xl font-heading font-semibold text-foreground mb-6">
        Member Engagement Trends
      </h3>
      <div className="w-full h-80" aria-label="Engagement Metrics Line Chart">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis
              dataKey="month"
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '14px' }}
            />
            <YAxis
              yAxisId="left"
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '14px' }}
            />
            <YAxis
              yAxisId="right"
              orientation="right"
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '14px' }}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: 'var(--color-card)',
                border: '1px solid var(--color-border)',
                borderRadius: '12px',
                padding: '12px'
              }}
            />
            <Legend
              wrapperStyle={{ paddingTop: '20px' }}
              iconType="circle"
            />
            <Line
              yAxisId="left"
              type="monotone"
              dataKey="avgScore"
              stroke="var(--color-primary)"
              strokeWidth={3}
              dot={{ fill: 'var(--color-primary)', r: 5 }}
              activeDot={{ r: 7 }}
              name="Avg Engagement Score"
            />
            <Line
              yAxisId="right"
              type="monotone"
              dataKey="atRisk"
              stroke="var(--color-warning)"
              strokeWidth={3}
              dot={{ fill: 'var(--color-warning)', r: 5 }}
              activeDot={{ r: 7 }}
              name="At-Risk Members"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default EngagementMetricsChart;